import { render, staticRenderFns } from "./unassignedlistmobile.vue?vue&type=template&id=3562098e&"
import script from "./unassignedlistmobile.vue?vue&type=script&lang=js&"
export * from "./unassignedlistmobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports